<template>
  <div class="modal" :class="[
    { 'modal-open': isOpen },
  ]">
    <div class="modal-background" @click.self="hide"></div>
    <div class="modal-overlay">
      <div class="modal-header">
        <h2 class="modal-header__title">
          How to ...
        </h2>
        <button class="modal-header__close" @click="hide">
          <i class="modal-header__close-icon">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.292961 0.292826C0.683522 -0.0976612 1.31669 -0.0976008 1.70717 0.292961L6.99899 5.58579L12.293 0.292826C12.6835 -0.0976612 13.3167 -0.0976009 13.7072 0.292961C14.0977 0.683522 14.0976 1.31669 13.707 1.70717L8.41371 6.9995L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L7 8.41421L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L5.58528 7.00051L0.292826 1.70704C-0.0976612 1.31648 -0.0976008 0.683313 0.292961 0.292826Z"
                fill="black" />
            </svg>
          </i>
        </button>
      </div>
      <div class="modal-body">
        <div class="modal-body__content">
          <template v-if="videoSrc">
            <video-player
              :videoSources="[{
                src: videoSrc,
                type: 'video/mp4',
              }]"
              title="Guide"
              loader="Loading..."
            ></video-player>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import pinia from '../../core/pinia';
import { useConfigStore, useModalStore } from '../../stores';
import uuid4 from '../../utils/uuid4';
import { E_MODAL } from '../../types/modals.enum';
import VideoPlayer from '../../components/ui/VideoPlayer.vue';
import emitter from '../../core/emitter';

const modalStore = useModalStore(pinia);
const configStore = useConfigStore(pinia);

const isOpen = ref(false);
const currentKey = ref('');

const videoSrc = computed(() => configStore.getVideoData.src);

function register() {
  currentKey.value = uuid4();
  modalStore.register(E_MODAL.GUIDE_MODAL, currentKey.value);
}

function hide() {
  modalStore.hide(currentKey.value);
  emitter.emit('modal:guide:close');
}

onMounted(() => {
  register();
  modalStore.$subscribe((_, state) => {
    const modalId = modalStore.getModalIdByKey(currentKey.value);
    if (modalId != -1) {
      isOpen.value = state.modals[modalId].isOpen;
    }
  });
});
</script>

<style scoped lang="scss">
.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  max-height: 100vh;
  z-index: 998;
  align-items: center;
  justify-content: center;
}

.modal-open {
  display: flex;
}

.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.modal-overlay {
  background-color: #fff;
  z-index: 1000;
  max-width: 854px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 20px 20px 0 20px;

  &__title {
    margin: 0;
    font-family: 'Montserrat';
    font-weight: 700;
    font-style: Bold;
    font-size: 20px;
    line-height: 26px;
    letter-spacing: 0%;
    color: #64747C;
  }

  &__close {
    background: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    cursor: pointer;
  }
}

.modal-body {
  &__content {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
}
</style>